import { cronosClient } from "@/config/client"

export type UserEventCategory = "work" | "study" | "wellness" | "recreation" | "study_time"

export interface UserEvent {
  id: string
  startDate: string
  endDate: string
  day: number
  parent: {
    id: string
    title: string
    createdBy: "university" | "user"
    days: number[]
    color: string
    category: UserEventCategory
  }
}

interface Response {
  description: UserEvent[]
}

interface Params {
  startDate: string
  endDate: string
  category?: UserEventCategory
}

export function getAll(params: Params) {
  return cronosClient.get<Response>("/v1/user/events", {
    params,
  })
}
